import { supabase } from "@/lib/supabase/supabaseClient";
import { TransferOrganizationOwnershipProps } from ".";

/**
 * Transfers organization ownership by updating the owner_id in the organisation table
 * @param newOwnerId The ID of the user who will become the new owner
 * @param orgId The organization ID
 * @returns The result of the update operation
 */
export const transferOrganizationOwnership = async ({
    newOwnerId,
    orgId
}: TransferOrganizationOwnershipProps) => {
    return await supabase
        .from('organisation')
        .update({ owner_id: newOwnerId })
        .eq('id', orgId)
        .throwOnError()
};
